import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ClientAccount, ClientAccountStyleGuidesArgs, Maybe, StyleGuide } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TVariables = ClientAccountStyleGuidesArgs;
type TData = Maybe<StyleGuide>;

const MOCK: TVariables = {
  id: undefined
};

export const styleGuideQueryFnAndKey = (variables: TVariables = MOCK) => {
  const client = clientUtil();

  const graphql = gql`
    query styleGuide($id: ID) {
      clientAccount {
        styleGuides(id: $id) {
          id
          approved
          referenceId
          name
          sections {
            languageCode
            section {
              included
              sectionKey
              items {
                extraInfo
                included
                itemKey
                selected
                text
              }
            }
          }
        }
      }
    }
  `;

  return {
    queryKey: ['styleGuide', ...buildQueryKey({ ...MOCK, ...variables })],
    queryFn: async () =>
      (
        (await client.request({
          data: {
            gql: graphql,
            variables
          }
        })) as ClientAccount
      )?.styleGuides?.at(0)
  };
};

export const useStyleGuide = (
  variables: ClientAccountStyleGuidesArgs,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  return useQuery<unknown, TGenericError, TData>({
    ...options,
    ...styleGuideQueryFnAndKey(variables)
  });
};
